import * as React from "react";
import {useDispatch} from "react-redux";
import {useLocation} from "react-router";
import {Link} from "react-router-dom";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import {Formik} from "formik";
import {parseSearch} from "@web2/ap-request";
import {apAppLink} from "@web2/ap-routes";
import {Button} from "@web2/button";
import {getFormikFieldProps, IFormikSubmitFn} from "@web2/formik_utils";
import {Input} from "@web2/input";

import {mv_lg, tac} from "../../app/styles/helpers";
import {logIn} from "../actions/login";

export const logoAp = require("../../app/img/logo_ap.svg");
const terms = require("../../app/asset/regulamin_panel_agenta.pdf");

const initialValues = {
    email: "",
    password: ""
};

export const LoginForm = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    const onSubmit: IFormikSubmitFn<typeof initialValues> = (formData, formikHelpers) => {
        const query = parseSearch(location.search);
        dispatch(logIn(formData.email, formData.password, query.next as string | undefined));

        formikHelpers.setSubmitting(false);
    };

    return (
        <div css={authBoxHolder}>
            <AuthLogo />

            <Formik initialValues={initialValues} onSubmit={onSubmit}>
                {(formikProps) => (
                    <form onSubmit={formikProps.handleSubmit}>
                        <Input {...getFormikFieldProps(formikProps, "email")} type="email" placeholder="Email" autoFocus required errorOnBottom />

                        <Input {...getFormikFieldProps(formikProps, "password")} type="password" placeholder="Hasło" required errorOnBottom />

                        <div css={[tac]}>
                            <Link to={apAppLink.passwordReset()}>Kliknij tutaj jeśli nie pamiętasz hasła</Link>
                        </div>

                        <div css={[tac, mv_lg]}>
                            <Button type="submit" size="lg" variant="primary" disabled={formikProps.isSubmitting}>
                                Zaloguj się
                            </Button>
                        </div>

                        {/*<p css={[m_0, tac]}>
                            Logując się akceptujesz{" "}
                            <a css={[c_text, tdu]} href={terms} target="_blank">
                                regulamin [zmienić plik]
                            </a>
                        </p>*/}
                    </form>
                )}
            </Formik>
        </div>
    );
};

export const authBoxHolder = css`
    background-color: #fff;
    padding: 3rem;
    width: 340px;
`;

export const AuthLogo = styled.div`
    margin: 1rem auto 3rem;
    height: 5rem;
    background-image: url(${logoAp});
    background-position: center center;
    background-repeat: no-repeat;
`;
